import type { BigIntish } from '@morpho-org/blue-sdk'

import { isDefined } from '@morpho-org/morpho-ts'

/**
 * Converts a value to BigInt while preserving null and undefined.
 * @param value - BigIntish value, null, or undefined to convert
 * @returns Converted BigInt or preserved null/undefined
 */
export function toBigInt(value: null): null
export function toBigInt(value: undefined): undefined
export function toBigInt(value: BigIntish): bigint
export function toBigInt(value: BigIntish | null): bigint | null
export function toBigInt(value: BigIntish | undefined): bigint | undefined
export function toBigInt(value: BigIntish | null | undefined): bigint | null | undefined

export function toBigInt(value: BigIntish | null | undefined): bigint | null | undefined {
  if (!isDefined(value)) {
    return value
  }
  return BigInt(value)
}
